export default {"src":"/_next/static/media/moneyBagWithCoins.0094ea69.svg","height":161,"width":227,"blurWidth":0,"blurHeight":0};